import { render, staticRenderFns } from "./dataTableSerie.vue?vue&type=template&id=2d91ffda&scoped=true"
import script from "./dataTableSerie.vue?vue&type=script&lang=js"
export * from "./dataTableSerie.vue?vue&type=script&lang=js"
import style0 from "./dataTableSerie.vue?vue&type=style&index=0&id=2d91ffda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d91ffda",
  null
  
)

export default component.exports